export const idx_data_surface = [];

idx_data_surface.push({
  surface: '',
});

idx_data_surface.push({
  surface: '180 Abralon',
});

idx_data_surface.push({
  surface: '360 Abralon',
});

idx_data_surface.push({
  surface: '500 Abralon',
});

idx_data_surface.push({
  surface: '1000 Abralon',
});

idx_data_surface.push({
  surface: '2000 Abralon',
});

idx_data_surface.push({
  surface: '3000 Abralon',
});

idx_data_surface.push({
  surface: '4000 Abralon',
});

idx_data_surface.push({
  surface: 'Compound',
});

idx_data_surface.push({
  surface: 'Polished',
});

idx_data_surface.push({
  surface: 'Slip Agent',
});

idx_data_surface.push({
  surface: 'Box',
});
